<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>
<script>
import CommonOnekidsService from "@/services/CommonService/CommonOnekidsService";

export default {
  name: "App",
  created() {
    this.refreshPermissions();
  },
  methods: {
    refreshPermissions() {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          let user = JSON.parse(userStr);
          // Kiểm tra xem đã đăng nhập chưa (có thông tin user) thì mới gọi API lấy quyền
          if (user && Object.keys(user).length > 0) {
            CommonOnekidsService.getApiAgain()
              .then((resp) => {
                if (resp && resp.data && resp.data.data) {
                  user.apiSet = resp.data.data;
                  localStorage.setItem("user", JSON.stringify(user));
                  this.$store.dispatch("auth/setUserActions", user);
                }
              })
              .catch((err) => {
                console.error("Lỗi cập nhật quyền khi reload trang:", err);
              });
          }
        } catch (e) {
          console.error("Lỗi parse user từ localStorage:", e);
        }
      }
    }
  }
};
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  height: 100%;
}
</style>

